import { InjectionToken } from '@angular/core';
import { CurrentModuleConfig } from '@portal-core/current/models/current-module-config.model';

export const CurrentModuleConfigService = new InjectionToken<CurrentModuleConfig>('CurrentModuleConfig');
